import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseCustomerRetention() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      title: isEmpty(state.title),
    };

    setter(errorState);

    if (errorState.title) {
      enqueueSnackbar("لطفا عنوان الگو را وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  function validate2(state, setter) {
    let errorState = {
      title: isEmpty(state.title),
      paternID: isEmpty(state.paternID),
      discountCodeID: isEmpty(state.discountCodeID),
      expiredate: isEmpty(state.expiredate),
    };

    setter(errorState);

    if (
      errorState.title ||
      errorState.paternID ||
      errorState.expiredate ||
      errorState.discountCodeID
    ) {
      enqueueSnackbar("لطفا اطلاعات کمپین را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const GetPatternsList = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_Marketing_CustomerRetention?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getAllPatternList = (callback) => {
    let newMypc = {
      page: 1,
      pageCount: 1,
      sortColumn: "Id",
      sortOrder: "Asc",
    };

    MyAxios.get(`Admin_Marketing_CustomerRetention`, {
      headers: {
        Conditions: JSON.stringify({ pageCondition: newMypc }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getPatternByID = (id, callback) => {
    MyAxios.get(`Admin_Marketing_CustomerRetention/${id}`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
            searchText: "",
            scrollTo: undefined,
            forceRefresh: false,
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const updatePattern = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.put(`Admin_Marketing_CustomerRetention`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("الگو با موفقیت ادیت شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const addPattern = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Marketing_CustomerRetention`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("الگو با موفقیت اضافه شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deletePattern = (id, callback) => {
    const data = new FormData();
    data.append("ID", id);
    MyAxios.delete(`Admin_Marketing_CustomerRetention`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("الگو با موفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  //////////////////////////////// campaign   //////////////////////////////////////////////

  const GetCampaignsList = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_Marketing_CustomerRetention/Campaign?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getCampaignByID = (id, callback) => {
    MyAxios.get(`Admin_Marketing_CustomerRetention/Campaign/${id}`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
            searchText: "",
            scrollTo: undefined,
            forceRefresh: false,
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const updateCampaign = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.put(`Admin_Marketing_CustomerRetention/Campaign`, data).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("کمپین با موفقیت ادیت شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const addCampaign = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Marketing_CustomerRetention/Campaign`, data).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("کمپین با موفقیت اضافه شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const deleteCampaign = (id, callback) => {
    const data = new FormData();
    data.append("ID", id);
    MyAxios.delete(`Admin_Marketing_CustomerRetention/Campaign`, {
      data: data,
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("کمپین با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const GetSMSTemplateList = (callback) => {
    MyAxios.get(`Admin_Marketing_CustomerRetention/sms`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const FillCampaign = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Marketing_CustomerRetention/fillcampaign`, data).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("کمپین با موفقیت محاسبه شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback(response.data.resault);
        }
      }
    );
  };

  const ActiveCampaign = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Marketing_CustomerRetention/activecampaign`, data).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("کمپین با موفقیت فعال شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const getAllDiscountCode = (callback) => {
    let newMypc = {
      page: 1,
      pageCount: 1,
      sortColumn: "Id",
      sortOrder: "Asc",
    };

    MyAxios.get(`Admin_DiscountManagment/Code`, {
      headers: {
        Conditions: JSON.stringify({ pageCondition: newMypc }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getCampaignCustomer = (myPc, id, callback) => {
    MyAxios.get(`Admin_Marketing_CustomerRetention/campaigncustomer/${id}`, {
      headers: {
        Conditions: JSON.stringify({ pageCondition: myPc }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getCampaignReport = (id, callback) => {
    MyAxios.get(`Admin_Marketing_CustomerRetention/report/${id}`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          callback(response.data.resault);
        }
      }
    );
  };

  return {
    validate,
    validate2,
    GetPatternsList,
    getPatternByID,
    updatePattern,
    addPattern,
    deletePattern,
    GetCampaignsList,
    getCampaignByID,
    updateCampaign,
    addCampaign,
    deleteCampaign,
    getAllPatternList,
    GetSMSTemplateList,
    FillCampaign,
    ActiveCampaign,
    getAllDiscountCode,
    getCampaignCustomer,
    getCampaignReport,
  };
}
